/* eslint-disable @typescript-eslint/naming-convention */
import { METHOD_TYPES } from "../../stateCommon/consts";
export const $methodKey = '$methods';
export const argsKey = '__source_method_arguments__';
export const renderCtxKey = '__renderer_context__';
export const injectCtxKey = '__injected_context__';
export const invokeCurrentMethodKey = 'invokeCurrentMethod';
export const defaultMethodConfig = {
  autoCatch: true,
  loading: true,
  type: METHOD_TYPES.code
  // debugCode: `await ${invokeCurrentMethodKey}();`,
};
export const initDesc = '页面和数据源加载完成后自动调用一次，用于初始化赋值和拉取数据';
const form = 'form';
const list = 'list';
// 为了不失去类型，就这样写了
export const METHOD_TEMPLATES = {
  [form]: {
    init: `${form}.init`,
    create: `${form}.create`,
    update: `${form}.update`,
    get: `${form}.get`,
    delete: `${form}.delete`,
    // 行级版本特有的方法
    rollback: `${form}.rollback`,
    historyList: `${form}.historyList`,
    publish: `${form}.publish`,
    getPublishStatus: `${form}.getPublishStatus`,
    historyCount: `${form}.historyCount`
  },
  [list]: {
    init: `${list}.init`,
    listCount: `${list}.listCount`,
    list: `${list}.list`,
    count: `${list}.count`,
    create: `${list}.create`,
    update: `${list}.update`,
    get: `${list}.get`,
    delete: `${list}.delete`,
    // 下面是没有可视化模式的
    save: `${list}.save`,
    newItem: `${list}.newItem`,
    saveSelected: `${list}.saveSelected`,
    deleteSelected: `${list}.deleteSelected`,
    copy: `${list}.copy`,
    // 本地分页搜索特有的方法
    local_init: `${list}.local_init`,
    local_getAllData: `${list}.local_getAllData`,
    local_list: `${list}.local_list`,
    // 行级版本特有的方法
    prodList: `${list}.prodList`,
    listWithStatus: `${list}.listWithStatus`,
    publish: `${list}.publish`,
    publishDeleteOp: `${list}.publishDeleteOp`,
    deleteOpList: `${list}.deleteOpList`,
    historyList: `${list}.historyList`,
    rollback: `${list}.rollback`,
    unpublishedList: `${list}.unpublishedList`,
    unpublishedCount: `${list}.unpublishedCount`,
    publishedList: `${list}.publishedList`,
    publishedCount: `${list}.publishedListCount`,
    prodCount: `${list}.prodCount`,
    deleteOpCount: `${list}.deleteOpCount`,
    historyCount: `${list}.historyCount`
  },
  any: {
    init: 'any.init',
    request: 'any.request'
  },
  custom: 'custom',
  empty: 'empty'
};
/**
 * 获取不同使用场景下的方法列表
 * @param usage
 * @returns
 */
export function getListTypes(usage) {
  const {
    list
  } = METHOD_TEMPLATES;
  const commonTypes = [list.create, list.update, list.get, list.delete, list.save, list.newItem, list.saveSelected, list.deleteSelected, list.copy];
  const types = usage === 'local' ? [list.local_init, list.local_getAllData, list.local_list] : [list.init, list.listCount, list.list, list.count];
  return [...types, ...commonTypes];
}
export function getRvListTypes(usage) {
  const {
    list
  } = METHOD_TEMPLATES;
  const commonTypes = [list.create, list.update, list.get, list.delete, list.save, list.newItem, list.saveSelected, list.deleteSelected, list.copy];
  const versionTypes = [list.listWithStatus, list.prodList, list.deleteOpList, list.historyList,
  // list.unpublishedList,//暂时不上已发布和未发布列表的数据源操作
  // list.publishedList,
  list.publish, list.publishDeleteOp, list.rollback, list.prodCount, list.deleteOpCount, list.historyCount
  // list.unpublishedCount,
  // list.publishedCount,
  ];
  const types = usage === 'local' ? [list.local_init, list.local_getAllData, list.local_list] : [list.init, list.listCount, list.list, list.count];
  return [...types, ...commonTypes, ...versionTypes];
}
export function getFormTypes() {
  const {
    form
  } = METHOD_TEMPLATES;
  return [form.init, form.create, form.get, form.delete, form.update];
}
export function getRvFormTypes() {
  const {
    form
  } = METHOD_TEMPLATES;
  return Object.values(form);
}
//# sourceMappingURL=consts.js.map
